module.exports = __webpack_public_path__ + "img/tante_Riek_muurtje_600x600px.12938dbe.png";